var React = require('react');

function IconArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1"},React.createElement("g",{"id":"icon-back","transform":"translate(3.000000, 2.000000)"},React.createElement("polygon",{"id":"Path-2","points":"2.12132034 15.5 16.5606602 29.9393398 14.4393398 32.0606602 -2.12132034 15.5 14.4393398 -1.06066017 16.5606602 1.06066017"}))));
}

IconArrowLeftInline.defaultProps = {"width":"20px","height":"35px","viewBox":"0 0 20 35","version":"1.1"};

module.exports = IconArrowLeftInline;

IconArrowLeftInline.default = IconArrowLeftInline;
